import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="section contact">
      <h2 className="section-title">Liên Hệ Với Chúng Tôi</h2>
      <form className="contact-form">
        <input type="text" placeholder="Tên của bạn" />
        <input type="email" placeholder="Email" />
        <textarea placeholder="Tin nhắn của bạn"></textarea>
        <button type="submit">Gửi</button>
      </form>
    </section>
  );
};

export default Contact;
